
import { db } from './firebaseInit'

export const saveCoinToDB = (coin) => () => {
	db().ref('coins').child(coin.id).set({ ...coin, date: Math.round(new Date().getTime() / 1000) })
}

export const toggleFavorite = (coinID) => {
  let favoriteCoins = localStorage['favorites'] || ''

  favoriteCoins.indexOf(coinID) >= 0
    ? (favoriteCoins = favoriteCoins.replace(coinID, ''))
    : (favoriteCoins += coinID)

	localStorage.setItem('favorites', favoriteCoins);
}

export const deleteCoinFromDB = (id: string) => () => {
	db().ref('coins').child(id).child('deleted').set(true)
}

export const manipulateCoins = (updates) => {
  db().ref('coins').update(updates).then(() => console.log('FINISHED'))
}



// WEBPACK FOOTER //
// ./src/actions/coins.js